import React, { useState, useEffect } from 'react';
import { Box, Typography, Fade } from '@mui/material';

const LoadingScreen = () => {
    const [step, setStep] = useState(1); // 1: Budscube, 2: Spicy Aliyadans

    useEffect(() => {
        const timer = setTimeout(() => {
            setStep(2);
        }, 1500);
        return () => clearTimeout(timer);
    }, []);

    return (step === 1 ? (
        <Fade in={step === 1} timeout={500}>
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    bgcolor: 'background.paper',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }}
            >
                <Box sx={{ position: 'relative', width: 120, height: 120, mb: 4 }}>
                    <Box sx={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        border: '3px solid transparent',
                        borderTopColor: 'primary.main',
                        borderBottomColor: 'secondary.main',
                        borderRadius: '50%',
                        animation: 'spin 3s linear infinite'
                    }} />
                    <Box
                        component="img"
                        src="/buds-logo.png"
                        alt="Buds Logo"
                        sx={{
                            position: 'absolute',
                            width: '45%',
                            height: '45%',
                            top: '27.5%',
                            left: '27.5%',
                            objectFit: 'contain',
                            animation: 'breathe 2s ease-in-out infinite'
                        }}
                    />
                </Box>
                <Box sx={{ textAlign: 'center' }}>
                    <Box
                        component="img"
                        src="/buds-full-logo.png"
                        alt="Budscube"
                        sx={{ height: 32, width: 'auto' }}
                    />
                </Box>
            </Box>
        </Fade>
    ) : (
        <Fade in={step === 2} timeout={800}>
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    bgcolor: 'background.paper',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }}
            >
                <Box
                    component="img"
                    src="/logo-spicy.png"
                    alt="Spicy Aliyadans Logo"
                    sx={{
                        width: isMobile ? 200 : 280,
                        height: 'auto',
                        mb: 3,
                        filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.05))'
                    }}
                />
                <Typography variant="h5" fontWeight={800} sx={{ color: 'primary.main', letterSpacing: 1 }}>
                    SPICY ALIYADANS
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, fontWeight: 700, textTransform: 'uppercase', opacity: 0.6 }}>
                    Modern Agri-Tech Vertical Farming
                </Typography>

                {/* Loading Indicator */}
                <Box sx={{
                    mt: 6,
                    width: 60,
                    height: 4,
                    bgcolor: 'divider',
                    borderRadius: 2,
                    overflow: 'hidden',
                    position: 'relative'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        height: '100%',
                        width: '40%',
                        bgcolor: 'primary.main',
                        borderRadius: 2,
                        animation: 'loadingSlide 1.5s ease-in-out infinite'
                    }} />
                </Box>
            </Box>
        </Fade>
    ));
};

const isMobile = window.innerWidth < 600;

export default LoadingScreen;
